<template>
  <div 
    class="collapse-wrapper"
    :class="{ 'collapsed': isCollapsed }"
  >
    <div 
      v-show="!isCollapsed"  
      class="sidebar-container"      
    >
      <slot />
    </div>
    <button
      class="collapse-btn"
      :aria-label="`Toggle Sidebar`"
      @click="isCollapsed = !isCollapsed"
    >
      <span class="collapse-icon">{{ isCollapsed ? '►' : '◄' }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const isCollapsed = ref(false);
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables' as *;

.collapse-wrapper {
  width: $side-bar-width;
  height: 100%;
  position: relative;
  flex-shrink: 0;

  &.collapsed {
    width: 0;
  }
}

.sidebar-container {
  position: fixed;
  top: 0;
  left: 0;
  width: $side-bar-width;
  height: 100vh;
  z-index: 999;
  background: white;
  border-right: 1px solid #dee2e6;
}

.collapse-btn {
  position: fixed;
  top: 0;
  left: 0;
  width: 32px;
  height: 32px;
  background: white;
  border: 1px solid #dee2e6;
  border-top: none;
  border-left: none;
  cursor: pointer;  
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  
  &:hover {
    background-color: #f8f9fa;
  }
}

.collapse-icon {
  font-size: 0.8rem;
  color: #666;
}
</style>
